import { UserCircle, EnvelopeSimple } from "@phosphor-icons/react";

const ContactsList = ({ contacts = [] }) => {
  return (
    <div data-testid="contacts-list">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading font-bold text-lg tracking-tight">
          Contactos de emergencia
        </h2>
        <span className="text-xs uppercase tracking-[0.25em] text-white/50">
          {contacts.length} {contacts.length === 1 ? "contacto" : "contactos"}
        </span>
      </div>
      {contacts.length === 0 ? (
        <div className="bg-surface border border-dashed border-border rounded-xl p-6 text-center text-white/50 text-sm">
          No hay contactos configurados.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {contacts.map((c, idx) => (
            <div
              key={`${c.email}-${idx}`}
              className="bg-surface border border-border rounded-xl p-4 flex items-center gap-3 hover:border-aqua/40 transition-colors"
              data-testid={`contact-row-${idx}`}
            >
              <div className="w-10 h-10 rounded-full bg-aqua/10 border border-aqua/30 flex items-center justify-center text-aqua shrink-0">
                <UserCircle size={22} weight="duotone" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="font-medium text-white truncate">{c.name}</div>
                <div className="flex items-center gap-1.5 text-xs text-white/55 truncate mono font-mono">
                  <EnvelopeSimple size={12} weight="bold" />
                  <span className="truncate">{c.email}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContactsList;
